import annotationService from 'services/AnnotationService';

class AnnotationServices {
  constructor({ target }) {
    this.target = target;
  }

  static build(...args) {
    return new AnnotationServices(...args);
  }

  getAnnotationsByMotivation(motivation) {
    return annotationService.getAnnotationsByMotivation(motivation, this.target);
  }

  getAnnotationById(motivation, annotationId) {
    return annotationService.getAnnotationById(motivation, annotationId, this.target);
  }

  subscribeToAnnotationMotivation(motivation, callback , elementId =null) {
    return annotationService.subscribeToAnnotationMotivation(motivation, this.target, callback, elementId);
  }

  setAnnotationBody(annotationId, body) {
    return annotationService.setAnnotationBody(annotationId, body, this.target);
  }

  createAnnotation(motivation, body, subTarget) {
    return annotationService.createAnnotation(motivation, body, this.target, subTarget);
  }

  resolveAnnotation(annotationId, annotationVersion, annnotations) {
    return annotationService.resolveAnnotation({ annotationId, annotationVersion, annnotations, target: this.target });
  }

  readAnnotation(annotationIds){
    return annotationService.readAnnotation(annotationIds, this.target);
  }
  
  unreadAnnotation(annotationIds){
    return annotationService.unreadAnnotation(annotationIds, this.target);
  }

  deleteAnnotation(annotationId) {
    return annotationService.deleteAnnotation(annotationId, this.target);
  }

  subscribeToEvent(eventName, callback) {
    return annotationService.subscribeToEvent(eventName, callback);
  }

  getSubscribers(eventName) {
    return annotationService.getSubscribers(eventName);
  }

}

export default AnnotationServices;
